var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCameraTakePicture = function SvgCameraTakePicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 20.167a9.167 9.167 0 110-18.334 9.167 9.167 0 010 18.334zm0-1.834a7.333 7.333 0 100-14.666 7.333 7.333 0 000 14.666zM15.583 11a4.583 4.583 0 11-9.166 0 4.583 4.583 0 019.166 0z"
  })));
};
export default SvgCameraTakePicture;